import React, { memo, useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isAutomaticLoad } from '../../helpers/common';
import { secondsToTime, toDisplayDateTimeString, toDisplayTimeString } from '../../helpers/moment-ex';
import { formatNumber, Unit } from '../../helpers/unit';
import { DataTable, Icon, Modal } from '../widgets';
import {
	deleteLoad as deleteSeedLoad, removeLogisticsLoads, setEditedLogisticsHistory, setSelectedIds,
    /* getLogisticsHistory, */ editLogisticsLoad,
	updateLogisticsLoad
} from "../../actions/logistics";
import LogisticsForm from './LogisticsForm';
import { LogisticsNotePopup } from "./LogisticsNotePopup";
import { useParams } from 'react-router-dom';
import { SubNav } from '../layout/submenu';
import LogisticsLocationPopup from './LogisticsLocationPopup';
import { Badge } from 'react-bootstrap';
import LoadSample from '../../constants/LoadSample';


const LogisticsRow = ({ data, index, unknownColumns, header }) => {
	const unit = Unit.getInstance();
	const dispatch = useDispatch();
	const params = useParams();
	const farmId = params.farmId;
	/* const { crewId, egId, isTruck, type } = params; */

	const { selectedLoads, payload, data: seedData, enableBulkEdit } = useSelector(state => state.logistics.logisticsHistory);
	/* const { range, custom } = useSelector(state => state.analyze.searchParams); */
	const selectedPlanType = useSelector(state => state.plan.selectedPlanType);
	const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
	/* const [isSampleSaving, setIsSampleSaving] = useState(false); */
	const [selected, setSelected] = useState(false);
	const [deleteLoad, setDeleteLoad] = useState(null);
	const [planTypeId, setPlanTypeId] = useState([]);
	const [showModal, setShowModal] = useState({
		edit: false,
		delete: false,
		location: false,
		loadSample: false,
		loadSampleProfileTable: false
	});

	const getClassName = field => !field || field === 'Unknown' ? 'text-danger' : '';

	const { load_activity_uuid, source_operator_name, operator_name } = data;

	const sourceEgOpertor = useMemo(() => source_operator_name && source_operator_name !== 'Unknown' ? source_operator_name : null, [source_operator_name]);
	const targetEgOpertor = useMemo(() => operator_name && operator_name !== 'Unknown' ? operator_name : null, [operator_name]);
	// const sourceFieldName = useMemo(() => source_field_name ? source_field_name : 'Unknown', [source_field_name]);
	// const seedVariety = useMemo(() => variety_name ? variety_name : variety ? variety : 'Unknown', [variety_name]);
	// const seedSupplier = useMemo(() => supplier ? supplier : 'Unknown', [supplier]);
	// const seedLot = useMemo(() => seed_lot ? seed_lot : 'Unknown', [seed_lot]);
	// const seedType = useMemo(() => seed_type ? seed_type : 'Unknown', [seed_type]);
	// const seedClass = useMemo(() => load_params && load_params.seed_class ? load_params.seed_class : 'Unknown', [load_params]);
	// const seedCuttingGroup = useMemo(() => seed_cutting_group ? seed_cutting_group : 'Unknown', [seed_cutting_group]);
	// const averageSeedSize = useMemo(() => average_seed_size ? average_seed_size : 'Unknown', [average_seed_size]);
	const isClonedLoad = (data.parent_load_activity_uuid) ? true : false;
	const isWebfmLoad = data.hasOwnProperty('meta_data') && data.meta_data.includes("null") ? true : false;

	useEffect(() => {
		if (farmSettings && farmSettings.seed_load_sample && farmSettings.seed_load_sample.plan_type_ids)
			return setPlanTypeId(farmSettings.seed_load_sample.plan_type_ids)
	}, [farmSettings, selectedPlanType]);

	const handleDeleteLoad = () => {
		dispatch(deleteSeedLoad({ load_activity_uuid: deleteLoad }, async (isDeleted) => {
			if (isDeleted) {
				setShowModal({ ...showModal, delete: false });
				dispatch(removeLogisticsLoads([deleteLoad]))
				setDeleteLoad(null);
			}
		}));
	}

	const handleSelect = () => {
		const index = selectedLoads.indexOf(load_activity_uuid);
		if (index > -1) {
			const updatedLoad = seedData.history.map((e, index) => e.load_activity_uuid === load_activity_uuid ? payload.history[index] : e);
			dispatch(setEditedLogisticsHistory({ updatedLoad }));
			const updatedIds = selectedLoads.filter((e, i) => i !== index);
			dispatch(setSelectedIds(updatedIds));
		} else {
			dispatch(setSelectedIds([...selectedLoads, load_activity_uuid]));
		}
		setSelected(!selected);
	};

	const showColumn = (key) => {
		if (enableBulkEdit || !unknownColumns || unknownColumns.length === 0) return true;
		return unknownColumns.indexOf(key) === -1;
	}

	const saveLoadSample = (saveLoad) => {
		dispatch(editLogisticsLoad(saveLoad, ((isSaved, params) => {
			if (isSaved) {
				dispatch(updateLogisticsLoad(data.load_activity_uuid, params));
			}
		})))
	}

	const handleShowModal = (type, show) => setShowModal({ ...showModal, [type]: show });

	const handleRatePopUpClick = (e) => {
		const allItems = document.querySelectorAll(".rate_columns");
		allItems.forEach((item) => item.classList.remove("active"));
		e.currentTarget.classList.add("active");
	};

	const handleRatePopUpClose = (e) => {
		e.preventDefault();
		const allItems = document.querySelectorAll(".rate_columns");
		setTimeout(() => {
			allItems.forEach((item) => item.classList.remove("active"));
		}, 100)
	};

	const headerKeyList = header.filter(it => showColumn(it.key) && it.isShow && (it.key !== "id") ? it.key : null).map(it => it.key);
	const tableValues = () => headerKeyList.map((headerKey) => {
		switch (headerKey) {
			case "approved": return (<DataTable.Cell key={`table_row-${headerKey}`}>
				{(data.approved && data.approved === "Yes") ?
					<>
						<Badge
							title="Approved"
							variant="success"
							className="badge-sm mr-2" pill>
							<Icon className="fa fa-check" />
						</Badge> {toDisplayDateTimeString(data.approved_date_tz, false, false)}
					</> :
					<Badge
						title="Not Approved"
						variant="danger"
						className="badge-sm" pill>
						<Icon className="fa fa-times" />
					</Badge>}
			</DataTable.Cell >)
			case "load_gross_weight":
			case "tare_weight":
			case "light_weight":
			case "load_capacity":
				return (<DataTable.Cell key={`table_row-${headerKey}`} className={getClassName(data[headerKey] || "0")}>{formatNumber(unit.toRoundOfWeight(data[headerKey], 2))}</DataTable.Cell>)
			case 'action': return (<DataTable.Cell key={`table_row-${headerKey}`}>
				<div className='seed-action d-flex'>
					<div><LogisticsNotePopup load={data} /></div>
					{farmSettings && farmSettings.seed_piece_profile_sample && farmSettings.seed_piece_profile_sample.visible && <div> <Icon
						title="Load Sample Profile Table"
						onClick={() => handleShowModal("loadSampleProfileTable", true)}
						className="fa fa-wpforms mx-1 cursor-pointer"
						ariaHidden="true" /></div>}
					{farmSettings && farmSettings.seed_load_sample && farmSettings.seed_load_sample.visible && planTypeId.includes(selectedPlanType) && <div> <Icon
						title="Load Sample"
						onClick={() => handleShowModal("loadSample", true)}
						className="fa fa-flask mx-1 cursor-pointer"
						ariaHidden="true" /></div>}
					<div>
						<Icon
							title={isWebfmLoad ? 'Location Not Found' : 'Location'}
							onClick={() => isWebfmLoad ? null : setShowModal({ ...showModal, location: true })}
							className="fa fa-map-marker cursor-pointer ml-2"
							ariaHidden="true" />
					</div>
					<div >
						<Icon
							title={"Edit"}
							ariaHidden="true"
							className="fa fa-pencil ml-2 cursor-pointer"
							onClick={() => setShowModal({ ...showModal, edit: true })}
						/>
					</div>
					<div >
						<Icon
							title={"Delete"}
							ariaHidden="true"
							className="fa fa-trash ml-2 cursor-pointer"
							onClick={() => {
								setDeleteLoad(load_activity_uuid);
								setShowModal({ ...showModal, delete: true });
							}}
						/>
					</div>
				</div>
			</DataTable.Cell>)
			case "load_date": return <DataTable.Cell key={`table_row-${headerKey}`} className={getClassName(data[headerKey])}>{toDisplayDateTimeString(data[headerKey], false, false)}</DataTable.Cell>
			case "load_seconds": return <DataTable.Cell key={`table_row-${headerKey}`}><>{toDisplayTimeString(secondsToTime(data[headerKey], true))} {(data[headerKey] !== data.total_load_seconds) && <>{!isAutomaticLoad && <span className="text-muted"> / {toDisplayTimeString(secondsToTime(data.total_load_seconds, true))}</span>}</>}</></DataTable.Cell>
			case "round_trip_load_time_format": return <DataTable.Cell key={`table_row-${headerKey}`}>{data[headerKey]}</DataTable.Cell>
			case "target_equipment_group_name": return <DataTable.Cell key={`table_row-${headerKey}`} className={getClassName(data[headerKey])}>{data[headerKey]} {targetEgOpertor && <span className='text-muted'> | {targetEgOpertor}</span>}</DataTable.Cell>
			case "source_equipment_group_name": return <DataTable.Cell key={`table_row-${headerKey}`} className={getClassName(data[headerKey])}>{data[headerKey]} {sourceEgOpertor && <span className='text-muted'> | {sourceEgOpertor}</span>}</DataTable.Cell>
			case "rate_info": {
				const cellValue = data["rate_info"] ? data["rate_info"] : {};
				return (
					<DataTable.Cell key={index} style={{ minWidth: "100px", whiteSpace: 'nowrap' }}>
						{(cellValue && cellValue.rate_value) ? <div>
							<div className="rate_columns rate_samples" onClick={(e) => handleRatePopUpClick(e)}>
								<div className="rate_value mr-1">
									<i className="fa fa-usd"></i>
									{cellValue && (cellValue.rate_value !== cellValue.total) ? cellValue.total : cellValue.rate_value}
								</div>
								<i className="fa fa-info-circle" aria-hidden="true"></i>

								<div className="arrow_popover">
									<div className="popover">
										<div className="rate_header header_none">
											<span>Rate Details</span>
											<div onClick={(e) => handleRatePopUpClose(e)}>
												<i className="fa fa-times"></i>
											</div>
										</div>
										<div className="arrow left_center"></div>
										<div className="my-2">
											<div className="rate_lists">
												Rate{' '}
												<span className="rate_list_value"><i className="fa fa-usd"></i>{cellValue && cellValue.rate_value ? cellValue.rate_value : 0}{' '}</span>
												<strong>
													{cellValue.rate_type_name ? `(${cellValue.rate_type_name})` : null}
												</strong>
											</div>
											{cellValue && cellValue.surcharge_value ? <div className="rate_lists">
												Custom Surcharge{' '}
												<span className="rate_list_value"><i className="fa fa-usd"></i>{cellValue && cellValue.surcharge_value ? cellValue.surcharge_value : 0}{' '}</span>
												<strong>
													{cellValue.surcharge_type_name ? `(${cellValue.surcharge_type_name})` : null}
												</strong>
											</div> : null}
											{cellValue && cellValue.own_bed_rate_value ? <div className="rate_lists">
												Own Bed Rate{' '}
												<span className="rate_list_value"><i className="fa fa-usd"></i>{cellValue && cellValue.own_bed_rate_value ? cellValue.own_bed_rate_value : 0}{' '}</span>
											</div> : null}
											{cellValue && cellValue.additional_surcharge_percent ? <div className="rate_lists">
												Additonal Surcharge{' '}
												<span className="rate_list_value">{cellValue && cellValue.additional_surcharge_percent ? cellValue.additional_surcharge_percent : 0}</span>
												<strong>
													%
												</strong>
											</div> : null}
											<div className="rate_lists">
												Total{' '}
												<span className="rate_list_value"><i className="fa fa-usd"></i>{cellValue.total ? `${unit.toFixedOf(cellValue.total, 2)}` : null}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> : <div className="text-danger">Unknown</div>}
					</DataTable.Cell>)
			}
			default: return <DataTable.Cell key={`table_row-${headerKey}`} className={getClassName(data[headerKey])}>{data[headerKey] || 'Unknown'}</DataTable.Cell>
		}
	});
	return (
		<>
			<DataTable.Row style={{ backgroundColor: (isWebfmLoad && !isClonedLoad) ? '#e2ffe9' : null }} className={`${(data.transfer_type === 2 && !isClonedLoad) && 'cart-type'} ${isClonedLoad ? 'is-cloned' : ''}`}>
				{enableBulkEdit &&
					<DataTable.Cell width="40px">
						<div style={{ paddingBottom: '18px', overflow: 'hidden' }}>
							<SubNav.Checkbox
								className="square"
								onChange={() => handleSelect()}
								checked={selectedLoads.includes(load_activity_uuid)}
							/>
						</div>
					</DataTable.Cell>}
				<DataTable.Cell width="30px" id={load_activity_uuid}>{index}</DataTable.Cell>
				{tableValues()}
			</DataTable.Row>

			<LogisticsForm
				farmId={farmId}
				show={showModal.edit}
				isCloned={false}
				onHide={() => setShowModal({ ...showModal, edit: false })}
				load={data}>
			</LogisticsForm>

			<LogisticsLocationPopup
				farmId={farmId}
				show={showModal.location}
				onHide={() => setShowModal({ ...showModal, location: false })}
				load={data}
			>
			</LogisticsLocationPopup>

			<Modal.Confirm
				className="modal-bordered"
				show={showModal.delete}
				onConfirm={() => handleDeleteLoad()}
				onHide={() => {
					setShowModal({ ...showModal, delete: false });
					setDeleteLoad(null);
				}}
				iconClassName="fa fa-question"
				title={{ content: "Confirmation" }}
				content={`Do you want to delete?`}
			/>

			{
				showModal.loadSample && <LoadSample
					show={showModal.loadSample}
					onHide={() => setShowModal({ ...showModal, loadSample: false })}
					load={data}
					farmId={farmId}
					saveSample={saveLoadSample}
				/>
			}
			{
				showModal.loadSampleProfileTable && <LoadSample
					show={showModal.loadSampleProfileTable}
					onHide={() => setShowModal({ ...showModal, loadSampleProfileTable: false })}
					load={data}
					farmId={farmId}
					saveSample={saveLoadSample}
				/>
			}
		</>
	);
};
export default memo(LogisticsRow);